import { requestsSubHeaderProps } from "./data/sub-header-props";

export type IRequestController = ReturnType<typeof useRequestsController>;

export default function useRequestsController() {
  return ({
    requestsSubHeaderProps,
  });
}
